import React, { Fragment, useState } from "react";
import Dashboard from "components/Template/Dashboard";
import ArrowLeft from "icons/arrow-circle-left-green.svg";
import ConfirmWhite from "icons/confirm-circle-white.svg";
import Loading from "components/Loading";
import Button from "components/Button";
import TextInputAuth from "components/TextInputAuth";
import { schemaAddAdminAccount } from "./validation";
import handleErrors from "helpers/handleErrors";
import { useHistory } from "react-router-dom";
import { createAdmin } from "services/admin";
import toastMessage from "helpers/handleToastMessage";
import { ToastContainer } from "react-toastify";

type Props = {};

const BridgeTalkAdminStore: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();

  const [loading, setLoading] = useState<boolean>(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [errors, setErrors] = useState<any>();

  const addClass = () => {
    if (firstName && lastName && email) {
      return "bg-bt-green";
    }

    return "bg-bt-gray-500";
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      if (
        !schemaAddAdminAccount.isValidSync({
          firstName,
          lastName,
          email,
        })
      ) {
        handleErrors({
          schema: schemaAddAdminAccount,
          stateData: {
            firstName,
            lastName,
            email,
          },
          setErrorMessage: setErrors,
        });
        setLoading(false);
        return;
      }

      await createAdmin({
        name: `${firstName} ${lastName}`,
        email,
        subtype: "admin",
      });

      history.push("/bridge-talk-admin");
    } catch (error: any) {
      let message;
      if (error.response.data.error === "Email already in use.") {
        message = "Email already in use.";
        setErrors({ email: "This email is already in our database." });
      }
      toastMessage({
        message: message ? message : "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dashboard
      icon={ArrowLeft}
      title={"Add Admin Account"}
      breadcrumb={[
        {
          name: "Bridge Talk Admin",
          active: false,
          path: "/bridge-talk-admin",
        },
        { name: "Add Account", active: true },
      ]}
      children={
        <Fragment>
          <Loading loading={loading} />
          <div className="bg-bt-white p-6">
            <div className="flex flex-row items-center justify-center p-2">
              <div className="flex flex-col w-1/4">
                <div className="flex flex-row mb-4">
                  <div
                    className="font-nunito"
                    style={{
                      fontStyle: "normal",
                      fontWeight: "300",
                      fontSize: "20px",
                      lineHeight: "27px",
                    }}
                  >
                    Personal Information
                  </div>
                </div>
                <div className="mr-2">
                  <TextInputAuth
                    placeholder={"First name"}
                    label="First name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    isHelp={errors?.firstName}
                    helpText={errors?.firstName}
                  />
                </div>
              </div>
              <div className="flex flex-col w-1/4">
                <div className="ml-2">
                  <TextInputAuth
                    placeholder={"Last name"}
                    label="Last name"
                    value={lastName}
                    className="mt-10"
                    onChange={(e) => setLastName(e.target.value)}
                    isHelp={errors?.lastName}
                    helpText={errors?.lastName}
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-row items-center justify-center p-2">
              <div className="flex flex-col w-2/4">
                <TextInputAuth
                  placeholder={"Email"}
                  label="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  isHelp={errors?.email}
                  helpText={errors?.email}
                />
              </div>
            </div>
            <div className="flex flex-row justify-end mt-5 p-2">
              <Button
                label={"Create Account"}
                className={`h-14 w-44 ${addClass()} text-base text-white rounded-full font-sora font-medium2`}
                iconLeft={ConfirmWhite}
                onClick={handleSubmit}
              />
            </div>
          </div>
          <ToastContainer />
        </Fragment>
      }
    />
  );
};

export default BridgeTalkAdminStore;
